import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_ENDPOINT;

export const fetchRole = createAsyncThunk(
    'role/list', 
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/role/list`, {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            });

            return response.data.data;
        } catch (error) {
            console.error('Error fetching roles:', error);
            return rejectWithValue(error.response?.data || 'Failed to fetch items');
        }
    }
);

export const fetchCabang = createAsyncThunk(
  'cabang/list',
  async (_, { getState, rejectWithValue }) => {
    try {
      const token = getState().auth.token || localStorage.getItem('authToken');

      const response = await axios.get(`${API_URL}/cabang/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data; // langsung return array cabang
    } catch (error) {
      console.error('Error fetching cabang:', error);
      return rejectWithValue(error.response?.data || 'Failed to fetch cabang');
    }
  }
);

export const detailRole = createAsyncThunk(
    'role/detail', 
    async (id, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');

            const response = await axios.get(`${API_URL}/role/detail/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });            
            return response.data;
        } catch (error) {
            console.error('Error detail roles:', error);
            return rejectWithValue(error.response?.data || 'Failed to detail items');
        }
    }
);

export const createRole = createAsyncThunk(
    'role/store', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            
            const response = await axios.post(`${API_URL}/role/store`, item, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            return response.data; 
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to create item');
        }
    }
);

export const updateRole = createAsyncThunk(
    'user/update', 
    async (item, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            const response = await axios.put(`${API_URL}/role/update/${item.id}`, item, {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            });

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to update item');
        }
    }
);

export const deleteRole = createAsyncThunk(
    'role/delete', 
    async (id, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token || localStorage.getItem('authToken');
            await axios.delete(`${API_URL}/role/delete/${id}`, {
                headers: {
                Authorization: `Bearer ${token}`,
                },
            });

            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to delete item');
        }
    }
);

const roleSlice = createSlice({
    name: 'roles',
    initialState: {
        roles: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchRole.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchRole.fulfilled, (state, action) => {
            state.isLoading = false;
            state.roles = action.payload;
        })
        .addCase(fetchRole.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(fetchCabang.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(fetchCabang.fulfilled, (state, action) => {
            state.isLoading = false;
            state.cabangs = action.payload;
        })
        .addCase(fetchCabang.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        .addCase(detailRole.pending, (state) => {
            state.error = null;
        })
        .addCase(detailRole.fulfilled, (state, action) => {
            state.roleDetail = action.payload.data;
        })
        .addCase(detailRole.rejected, (state, action) => {
            state.error = action.payload;
        })
        .addCase(createRole.fulfilled, (state, action) => {
            state.roles.push(action.payload);
        })
        .addCase(updateRole.fulfilled, (state, action) => {            
            const index = state.roles.findIndex((item) => item.id === action.payload.data.id);
                if (index !== -1) {
                    state.roles[index] = { ...state.roles[index], ...action.payload.data };
                }
                state.isLoading = false;
        })
        .addCase(deleteRole.fulfilled, (state, action) => {
            state.roles = state.roles.filter((item) => item.id !== action.payload);
        });
    },
});

export default roleSlice.reducer;
